import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation, } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { fetchBusinessProfileById, updateBusinessProfileInSlice } from '../../store/businessProfileByIdSlice';
import { patchProfile } from '../../store/profileSlice';
import '../../css/business-profile.css';
import Spinner from '../../utils/Spinner';
import { toggleFavorite } from '../../services/favoritesService';
import BusinessReviews from './public/components/BusinessReviews';
import BusinessProfilePublicView from './public/BusinessProfilePublicView'
import BusinessProfileOwnerView from './own/BusinessProfileOwnerView';
import BusinessProfileModal from './own/components/BusinessProfileModal';

const BusinessProfileEntry = () => {
    const { id } = useParams();
    const location = useLocation();
    const { userId, accessToken } = useAuth(); // Assumes you have auth context that gives you `user`
    const dispatch = useDispatch();
    const { data, status, error } = useSelector((state) => state.businessProfileById);

    const [isOverlayOpen, setOverlayOpen] = useState(false);
    const profile = useSelector((state) => state.profile.data);
    const [loading, setLoading] = useState(true);

    const [isFavorited, setIsFavorited] = useState(false);
    const [favoriteCount, setFavoriteCount] = useState(false);

    const [isModalOpen, setModalOpen] = useState(false);


    const handleOverlayToggle = () => {
        setOverlayOpen(!isOverlayOpen);
    };

    const handleFavoriteToggle = async () => {
        try {
            const data = await toggleFavorite(id, "business", "POST");
            setIsFavorited(data.is_favorited);
            setFavoriteCount(data.favorited_count);
        } catch (error) {
            console.error("Error toggling favorite:", error);
        }
    };

    const handleUpdate = (updatedBusiness) => {
        // Update the public business profile
        dispatch(updateBusinessProfileInSlice(updatedBusiness));

        // Keep the authenticated profile's business name in sync
        dispatch(
            patchProfile({
                business_profile: {
                    ...profile.business_profile,
                    business_name: updatedBusiness.business_name,
                },
            })
        );
    };

    useEffect(() => {
        if (id) {

            const fetchFavoriteStatus = async () => {
                try {
                    const data = await toggleFavorite(id, "business", "GET");
                    setIsFavorited(data.is_favorited);
                    setFavoriteCount(data.favorited_count);
                } catch (error) {
                    console.error("Error fetching favorite status:", error);
                }
            };

            dispatch(fetchBusinessProfileById(id));
            fetchFavoriteStatus(id);
        }
    }, [id]);


    if (status === 'loading') return <Spinner />;
    if (status === 'failed') return <p>Error: {error}</p>;

    const isOwner =
        !!accessToken &&
        parseInt(id) === profile?.business_profile?.id;

    if (isOwner) {
        return (
            <>
                <BusinessProfileOwnerView
                    data={data}
                    isFavorited={isFavorited}
                    favoriteCount={favoriteCount}
                    handleFavoriteToggle={handleFavoriteToggle}
                    id={id}
                    isModalOpen={isModalOpen}
                    setModalOpen={setModalOpen}
                    handleUpdate={handleUpdate}
                />
                {isModalOpen && (
                    <BusinessProfileModal
                        data={data}
                        onClose={() => setModalOpen(false)}
                        handleUpdate={handleUpdate}
                    />
                )}
            </>
        );
    }

    return <BusinessProfilePublicView
        data={data}
        isFavorited={isFavorited}
        favoriteCount={favoriteCount}
        handleFavoriteToggle={handleFavoriteToggle}
        id={id}
    />;
};

export default BusinessProfileEntry;
